<template>
    <div class="container mt--5">
        <div class="row">
            <div class="col xs-8">
                <div class="card px-3 py-4">
                    <Tabs
                        firstOpenTab="content"
                        @selectedTab="setSelectedTab"
                        tabNavClasses="nav-fill flex-column flex-sm-row"
                        :color="color.primary"
                    >
                        <Tab title="content">
                            <template #title><span
                                @click.once="content = true"
                                class="nch--tab font-weight-bold"
                            >{{$t('course.tabs.content')}}</span></template>
                            <CourseContent
                                :active="content"
                                :course="course"
                                :color="color"
                                :public-user="publicUser"
                                :contents-api-url="contentsApiUrl"
                                :public-lesson-urls="publicLessonUrls"
                            />
                        </Tab>
                        <Tab title="overview">
                            <template #title><span
                                class="nch--tab font-weight-bold"
                            >{{$t('course.tabs.overview')}}</span></template>
                            <CourseOverview :course="course" :color="color" />
                        </Tab>
                        <Tab v-if="forum">
                            <template #title><span
                                @click="navigateForumHandler"
                                class="nch--tab font-weight-bold"
                            >{{$t('course.tabs.forum')}}</span></template>
                            <!-- <CourseForum :active="forum" /> -->
                        </Tab>
                        <!-- Glossário do curso (backlog#342): termos do curso + glossário geral -->
                        <Tab v-if="glossary && !publicUser" title="glossary">
                            <template #title><span
                                class="nch--tab font-weight-bold"
                            >{{$t('course.tabs.glossary')}}</span></template>
                            <Glossary v-if="currentTab === 'glossary'" :course-id="course.id" embedded />
                        </Tab>
                        <!-- Wiki da turma (backlog#343) -->
                        <Tab v-if="wiki && !publicUser" title="wiki">
                            <template #title><span
                                class="nch--tab font-weight-bold"
                            >{{$t('course.tabs.wiki')}}</span></template>
                            <WikiList v-if="currentTab === 'wiki'" :course-id="course.id" embedded />
                        </Tab>
                    </Tabs>
                    <span
                        v-if="this.courseWithoutContent && currentTab === 'content'"
                        class="text-center course-without-content"
                    >
                        {{$t('course.course_no_content')}}
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Tabs from '../../argon/components/Tabs/Tabs';
import Tab from '../../argon/components/Tabs/Tab';

import CourseOverview from './CourseOverview';
import CourseContent from './CourseContent';
import CourseForum from './CourseForum';
import Glossary from '../Glossary';
import WikiList from '../Wiki/WikiList';

export default {
    name: 'Container',
    data() {
        return {
            content: false,
            survey: false,
            currentTab: '',
            courseWithoutContent: false,
        };
    },
    components: {
        CourseOverview,
        CourseContent,
        CourseForum,
        Glossary,
        WikiList,
        Tabs,
        Tab,
    },
    props: {
        color: {
            type: Object,
        },
        course: {
            type: Object,
            require: true,
        },
        plan: {
            type: Number,
            required: true,
        },
        forum: {
            type: Object | Number,
        },
        layout: Object,
        publicUser: {
            type: Boolean,
            default: false,
        },
        contentsApiUrl: {
            type: String,
            default: '',
        },
        publicLessonUrls: {
            type: Object,
            default: () => ({}),
        },
        /** Glossário (backlog#342): mostra a aba Glossário do curso */
        glossary: {
            type: Boolean,
            default: false,
        },
        /** Wiki colaborativa (backlog#343): mostra a aba Wiki da turma */
        wiki: {
            type: Boolean,
            default: false,
        },
    },
    methods: {
        setSelectedTab(tab) {
            this.currentTab = tab;
        },
        navigateForumHandler() {
            this.$loading.show();
            window.location.href = `/app/plan/${this.plan}/course/forum/${this.forum.id}`;
        },
        async verifyCourseHasNoContent() {
            if (this.publicUser) {
                return false;
            }
            return window.axios
                .get(`/api/course/${this.course.id}/verify-has-contents`)
                .then(res => res.data.data.course_without_content)
                .catch(err => console.error(err));
        },
    },
    async mounted() {
        this.content = true;
        this.courseWithoutContent = await this.verifyCourseHasNoContent();
    },
};
</script>

<style scoped>
    .course-without-content {
        margin-top: 20px;
    }
</style>
